import { Card, CardContent, CardHeader, Stack } from '@mui/material';
import { t } from 'i18next';
import { InventoryComparisonTable } from './InventoryComparisonTable';
import { ReportSummary } from '../../summary/services/ReportSummaryRepository';
import { InventoryComparisonTableSkeleton } from './skeletons/InventoryComparisonTableSkeleton';

type Props = {
  currentReportSummary: ReportSummary | null;
  selectedReportSummary: ReportSummary | null;
  isLoading: boolean;
};

export const InventorySummaryCard = (props: Props) => {
  const { currentReportSummary, selectedReportSummary, isLoading } = props;
  const isLoadingData = currentReportSummary === null || selectedReportSummary === null || isLoading;

  return (
    <Card>
      <CardHeader title={t('comparison.inventory.title')} />
      <CardContent sx={{ p: 0, pb: '0 !important' }}>
        <Stack>
          {isLoadingData ? (
            <InventoryComparisonTableSkeleton />
          ) : (
            <InventoryComparisonTable currentReportSummary={currentReportSummary} selectedReportSummary={selectedReportSummary} />
          )}
        </Stack>
      </CardContent>
    </Card>
  );
};
